import { ViewModes } from '@allesauto/utils/consts';

import { PCPStateProps } from '@/store/redux/reducers/pages/pcp/page';
import { IReduxActionProps } from '@/store/redux/Utils';

export const SET_ITEMS_PER_PAGE = 'SET_ITEMS_PER_PAGE';
export const SET_VIEWMODE = 'SET_VIEWMODE';
export const SET_SORTING = 'SET_SORTING';
export const SET_FILTER_ACCORDION_OPEN_STATE =
  'SET_FILTER_ACCORDION_OPEN_STATE';
export const SET_FILTER_ACCORDION_OPEN_STATES =
  'SET_FILTER_ACCORDION_OPEN_STATES';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';

export const setItemsPerPage = (itemsPerPage: number): IReduxActionProps => {
  return {
    type: SET_ITEMS_PER_PAGE,
    payload: {
      itemsPerPage,
    },
  };
};

export const setPageNumber = (page: number): IReduxActionProps => {
  return {
    type: SET_PAGE_NUMBER,
    payload: {
      page,
    },
  };
};

export const setViewMode = (viewMode: ViewModes): IReduxActionProps => {
  return {
    type: SET_VIEWMODE,
    payload: {
      viewMode,
    },
  };
};

export const setSorting = (sorting: {
  subject: string;
  direction: string;
}): IReduxActionProps => {
  return {
    type: SET_SORTING,
    payload: {
      sorting,
    },
  };
};

export interface SetFilterAccordionOpenStateProps {
  filterId: string;
  open: boolean;
}

export const setFilterAccordionOpenState = ({
  filterId,
  open,
}: SetFilterAccordionOpenStateProps): IReduxActionProps => {
  return {
    type: SET_FILTER_ACCORDION_OPEN_STATE,
    payload: {
      filterId,
      open,
    },
  };
};

export const setFilterAccordionOpenStates = ({
  items,
}: PCPStateProps['filterAccordionStates']): IReduxActionProps => {
  return {
    type: SET_FILTER_ACCORDION_OPEN_STATES,
    payload: {
      items,
    },
  };
};
